module.exports = __webpack_public_path__ + "static/media/patrol(8).2a184083.PNG";